import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Typography } from '@mui/material'
import { TextField } from '@front/squirtle'

const SearchForm = () => <Box>
  <Typography textAlign='center' variant='h2' color='primary.main'>{I18n.t('import.list')}</Typography>
  <Box visibility='hidden'><TextField name='submitOnMount' /></Box>
</Box>

export default React.memo(SearchForm)
